import { render, staticRenderFns } from "./EntryDetails.vue?vue&type=template&id=741070a0&"
import script from "./EntryDetails.vue?vue&type=script&lang=js&"
export * from "./EntryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports